// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  height: 200vh; /* Adjust this height as needed */
  z-index: 1;
}
uredi-task .mat-autocomplete-panel {
  min-width: unset;
}
uredi-task .mat-form-field-flex {
  flex: 1;
}
uredi-task .mat-autocomplete-panel {
  margin-top: 11px;
}
uredi-task .mat-form-field {
  display: block;
}
uredi-task .mat-form-field-wrapper {
  padding-bottom: 0;
  border-top: 0;
}
uredi-task .mat-form-field-infix {
  border-top: 0;
}


.dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 200px; /* Set a maximum height for the dropdown */
  overflow-y: auto; /* Enable vertical scrolling if needed */
  z-index: 2;
}
.dotYellow {
  background-color: #FFFF66;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}

.dotGreen {
  background-color: lightgreen;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}

.dotRed {
  background-color: lightcoral;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}

.dotBlue {
  background-color: lightskyblue;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}

.dotGray {
  background-color: lightslategray;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}

.dotOrange {
  background-color: orange;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}

.dotPurple {
  background-color: purple;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}

.dotBrown {
  background-color: burlywood;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}
.dotDarkBlue {
  background-color: darkblue;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}
.dotBlack {
  background-color: black;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}

.form-control{
  box-shadow: none;
}

.btn{
  box-shadow: none;
}

@media(max-width: 900px){
  .textareaText {
    resize: none;
    height: 150px;
    width:100%;
    background-color:#FFF5E3 !important;
  }
}

@media(min-width: 900px){
  .textareaText {
    resize: none;
    height: 200px;
    width:90%;
    background-color:#FFF5E3 !important;
  }
}


button:focus, button:active:focus, button.active:focus {
  outline: none !important;
  outline-style: none !important;
  }

.row-height {
    height: 100%
}


/* Izpis texta */
.boldText {
  font-weight: bold;
}

.padLeft {
  padding-left: 10px;
}

/* */

/* to je zato da tab nima puščic (paginationa)*/
::ng-deep .mat-tab-header-pagination {
  display: none !important;
}

/* da ni scroll možnosti na tab itemu*/
::ng-deep .mat-tab-body-content {
  overflow: visible !important;
}

/*skrijem tab pa dam column podatke*/
@media(min-width: 1050px){

  .mobileHide {
    display: none;
    backface-visibility: hidden;
  }

}

@media(max-width: 1050px){

  .desktopHide {
    display: none;
  }

}

.dragDropContainer {
  border-style: dotted;
  border: 2px dashed black;
  border-radius: 10px;
  background-color: #FFF5E3;
}

/*drag and drop*/
.fileover {
  animation: shake 0.5s;
  animation-iteration-count: infinite;
}

.fa-search:hover {
  cursor: pointer;
  color: #f89624;
  transition: 0.35s;
}

@keyframes shake {
  0% { transform: translate(1px, 1px) rotate(0deg); }
  10% { transform: translate(-1px, -2px) rotate(-1deg); }
  20% { transform: translate(-3px, 0px) rotate(1deg); }
  30% { transform: translate(3px, 2px) rotate(0deg); }
  40% { transform: translate(1px, -1px) rotate(1deg); }
  50% { transform: translate(-1px, 2px) rotate(-1deg); }
  60% { transform: translate(-3px, 1px) rotate(0deg); }
  70% { transform: translate(3px, 1px) rotate(-1deg); }
  80% { transform: translate(-1px, -1px) rotate(1deg); }
  90% { transform: translate(1px, 2px) rotate(0deg); }
  100% { transform: translate(1px, -2px) rotate(-1deg); }
}

.buttonBilumina {
  background-color:#f89624;
  color:white;
  margin: 0;
  width:90px;
}

.paddingNone {
  padding: 0;
}
.example-container {
  position: fixed;
  top: 7%;
  left: 0;
  width: 150px;
  bottom: 0;
  z-index: 1;
  float: left;
}
.behind-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 150px;
  bottom: 0;
}

a {
  padding: 6px 8px 6px 16px;
  text-decoration: none;
  font-size: 18px;
  color: white;
  display: block;
  cursor: pointer;
}

a:hover {
  transition: 0.3s;
  color: orange;
}

.selectedLink {
  color: orange;
}

.nav {
  background-color: #292c2f;
}

mat-drawer {
  background: #292c2f !important;
}
.example-sidenav-container {
  /* When the sidenav is not fixed, stretch the sidenav container to fill the available space. This
     causes \`<mat-sidenav-content>\` to act as our scrolling element for desktop layouts. */
  flex: 1;
}

.example-is-mobile .example-sidenav-container {
  /* When the sidenav is fixed, don't constrain the height of the sidenav container. This allows the
     \`<body>\` to be our scrolling element for mobile layouts. */
  flex: 1 0 auto;
}

.example-is-mobile .example-toolbar {
  position: fixed;
  /* Make sure the toolbar will stay on top of the content as it scrolls past. */
  z-index: 2;
}

.nav-link {
  font-size: 18px;
}
.sidebarLtMd {
  margin: 0;
  padding: 0;
  width: 100%;
  background-color: #292c2f;
  height: 100%;
  overflow: hidden;
  overflow-x: hidden;

}


.sidenav {
  width: 216px;
  height: 100%;
  position: fixed;
  z-index: 1;
  overflow-x: hidden;
  background-color: #292c2f;
  padding: 8px 0;
  font-size: 18px;
  display: block;
  color: black;
}

.contentLtMd {
  width: 100%;
  overflow-x: hidden;
}
.content {
  margin-left: 216px;
  width: 100%;
  display:flex !important;
  padding: 1px 16px;
  overflow-x: hidden;
}

#overlay {
  background: #ffffff;
  color: #666666;
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 5000;
  top: 0;
  left: 0;
  float: left;
  text-align: center;
  padding-top: 25%;
  opacity: .80;
}

.hideNav {
  height: 100vh;
  width: 40px;
  position: fixed;
  z-index: 1;
  overflow-x: hidden;
  padding: 8px 0;
  font-size: 18px;
  display: block;
  color: black;
  background-color: #FFE8BF;
  transition: width 2s;
}

.divSide {
  height: 100vh;
  width: 216px;
  /*float:left;*/
  background-color: #292c2f;
  position: fixed;
}

.divHideSide {
  height: 100vh;
  width: 40px;
  float:left;
  background-color: #FFE8BF;
  position: fixed;
}

.marginWhenHiddenSidenav {
  margin-left: 0px;
}

.marginWhenSidenav {
  margin-left:216px;
}

.hidden {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/app/HELPDESK/uredi-task/uredi-task.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,aAAa,EAAE,iCAAiC;EAChD,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,OAAO;AACT;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,aAAa;AACf;;;AAGA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,iBAAiB,EAAE,0CAA0C;EAC7D,gBAAgB,EAAE,wCAAwC;EAC1D,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,0BAA0B;EAC1B,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,UAAU;IACV,mCAAmC;EACrC;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,SAAS;IACT,mCAAmC;EACrC;AACF;;;AAGA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B;;AAEF;IACI;AACJ;;;AAGA,gBAAgB;AAChB;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,IAAI;;AAEJ,+CAA+C;AAC/C;EACE,wBAAwB;AAC1B;;AAEA,sCAAsC;AACtC;EACE,4BAA4B;AAC9B;;AAEA,oCAAoC;AACpC;;EAEE;IACE,aAAa;IACb,2BAA2B;EAC7B;;AAEF;;AAEA;;EAEE;IACE,aAAa;EACf;;AAEF;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,KAAK,2CAA2C,EAAE;EAClD,MAAM,8CAA8C,EAAE;EACtD,MAAM,4CAA4C,EAAE;EACpD,MAAM,2CAA2C,EAAE;EACnD,MAAM,4CAA4C,EAAE;EACpD,MAAM,6CAA6C,EAAE;EACrD,MAAM,4CAA4C,EAAE;EACpD,MAAM,4CAA4C,EAAE;EACpD,MAAM,6CAA6C,EAAE;EACrD,MAAM,2CAA2C,EAAE;EACnD,OAAO,6CAA6C,EAAE;AACxD;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;AACA;EACE,eAAe;EACf,OAAO;EACP,OAAO;EACP,YAAY;EACZ,SAAS;EACT,UAAU;EACV,WAAW;AACb;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE;0FACwF;EACxF,OAAO;AACT;;AAEA;EACE;+DAC6D;EAC7D,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,8EAA8E;EAC9E,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;AACA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;;AAEpB;;;AAGA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,MAAM;EACN,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,cAAc;EACd,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,UAAU;EACV,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".overlay {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  height: 200vh; /* Adjust this height as needed */\n  z-index: 1;\n}\nuredi-task .mat-autocomplete-panel {\n  min-width: unset;\n}\nuredi-task .mat-form-field-flex {\n  flex: 1;\n}\nuredi-task .mat-autocomplete-panel {\n  margin-top: 11px;\n}\nuredi-task .mat-form-field {\n  display: block;\n}\nuredi-task .mat-form-field-wrapper {\n  padding-bottom: 0;\n  border-top: 0;\n}\nuredi-task .mat-form-field-infix {\n  border-top: 0;\n}\n\n\n.dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  max-height: 200px; /* Set a maximum height for the dropdown */\n  overflow-y: auto; /* Enable vertical scrolling if needed */\n  z-index: 2;\n}\n.dotYellow {\n  background-color: #FFFF66;\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.dotGreen {\n  background-color: lightgreen;\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.dotRed {\n  background-color: lightcoral;\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.dotBlue {\n  background-color: lightskyblue;\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.dotGray {\n  background-color: lightslategray;\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.dotOrange {\n  background-color: orange;\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.dotPurple {\n  background-color: purple;\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.dotBrown {\n  background-color: burlywood;\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n}\n.dotDarkBlue {\n  background-color: darkblue;\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n}\n.dotBlack {\n  background-color: black;\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.form-control{\n  box-shadow: none;\n}\n\n.btn{\n  box-shadow: none;\n}\n\n@media(max-width: 900px){\n  .textareaText {\n    resize: none;\n    height: 150px;\n    width:100%;\n    background-color:#FFF5E3 !important;\n  }\n}\n\n@media(min-width: 900px){\n  .textareaText {\n    resize: none;\n    height: 200px;\n    width:90%;\n    background-color:#FFF5E3 !important;\n  }\n}\n\n\nbutton:focus, button:active:focus, button.active:focus {\n  outline: none !important;\n  outline-style: none !important;\n  }\n\n.row-height {\n    height: 100%\n}\n\n\n/* Izpis texta */\n.boldText {\n  font-weight: bold;\n}\n\n.padLeft {\n  padding-left: 10px;\n}\n\n/* */\n\n/* to je zato da tab nima puščic (paginationa)*/\n::ng-deep .mat-tab-header-pagination {\n  display: none !important;\n}\n\n/* da ni scroll možnosti na tab itemu*/\n::ng-deep .mat-tab-body-content {\n  overflow: visible !important;\n}\n\n/*skrijem tab pa dam column podatke*/\n@media(min-width: 1050px){\n\n  .mobileHide {\n    display: none;\n    backface-visibility: hidden;\n  }\n\n}\n\n@media(max-width: 1050px){\n\n  .desktopHide {\n    display: none;\n  }\n\n}\n\n.dragDropContainer {\n  border-style: dotted;\n  border: 2px dashed black;\n  border-radius: 10px;\n  background-color: #FFF5E3;\n}\n\n/*drag and drop*/\n.fileover {\n  animation: shake 0.5s;\n  animation-iteration-count: infinite;\n}\n\n.fa-search:hover {\n  cursor: pointer;\n  color: #f89624;\n  transition: 0.35s;\n}\n\n@keyframes shake {\n  0% { transform: translate(1px, 1px) rotate(0deg); }\n  10% { transform: translate(-1px, -2px) rotate(-1deg); }\n  20% { transform: translate(-3px, 0px) rotate(1deg); }\n  30% { transform: translate(3px, 2px) rotate(0deg); }\n  40% { transform: translate(1px, -1px) rotate(1deg); }\n  50% { transform: translate(-1px, 2px) rotate(-1deg); }\n  60% { transform: translate(-3px, 1px) rotate(0deg); }\n  70% { transform: translate(3px, 1px) rotate(-1deg); }\n  80% { transform: translate(-1px, -1px) rotate(1deg); }\n  90% { transform: translate(1px, 2px) rotate(0deg); }\n  100% { transform: translate(1px, -2px) rotate(-1deg); }\n}\n\n.buttonBilumina {\n  background-color:#f89624;\n  color:white;\n  margin: 0;\n  width:90px;\n}\n\n.paddingNone {\n  padding: 0;\n}\n.example-container {\n  position: fixed;\n  top: 7%;\n  left: 0;\n  width: 150px;\n  bottom: 0;\n  z-index: 1;\n  float: left;\n}\n.behind-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 150px;\n  bottom: 0;\n}\n\na {\n  padding: 6px 8px 6px 16px;\n  text-decoration: none;\n  font-size: 18px;\n  color: white;\n  display: block;\n  cursor: pointer;\n}\n\na:hover {\n  transition: 0.3s;\n  color: orange;\n}\n\n.selectedLink {\n  color: orange;\n}\n\n.nav {\n  background-color: #292c2f;\n}\n\nmat-drawer {\n  background: #292c2f !important;\n}\n.example-sidenav-container {\n  /* When the sidenav is not fixed, stretch the sidenav container to fill the available space. This\n     causes `<mat-sidenav-content>` to act as our scrolling element for desktop layouts. */\n  flex: 1;\n}\n\n.example-is-mobile .example-sidenav-container {\n  /* When the sidenav is fixed, don't constrain the height of the sidenav container. This allows the\n     `<body>` to be our scrolling element for mobile layouts. */\n  flex: 1 0 auto;\n}\n\n.example-is-mobile .example-toolbar {\n  position: fixed;\n  /* Make sure the toolbar will stay on top of the content as it scrolls past. */\n  z-index: 2;\n}\n\n.nav-link {\n  font-size: 18px;\n}\n.sidebarLtMd {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  background-color: #292c2f;\n  height: 100%;\n  overflow: hidden;\n  overflow-x: hidden;\n\n}\n\n\n.sidenav {\n  width: 216px;\n  height: 100%;\n  position: fixed;\n  z-index: 1;\n  overflow-x: hidden;\n  background-color: #292c2f;\n  padding: 8px 0;\n  font-size: 18px;\n  display: block;\n  color: black;\n}\n\n.contentLtMd {\n  width: 100%;\n  overflow-x: hidden;\n}\n.content {\n  margin-left: 216px;\n  width: 100%;\n  display:flex !important;\n  padding: 1px 16px;\n  overflow-x: hidden;\n}\n\n#overlay {\n  background: #ffffff;\n  color: #666666;\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  z-index: 5000;\n  top: 0;\n  left: 0;\n  float: left;\n  text-align: center;\n  padding-top: 25%;\n  opacity: .80;\n}\n\n.hideNav {\n  height: 100vh;\n  width: 40px;\n  position: fixed;\n  z-index: 1;\n  overflow-x: hidden;\n  padding: 8px 0;\n  font-size: 18px;\n  display: block;\n  color: black;\n  background-color: #FFE8BF;\n  transition: width 2s;\n}\n\n.divSide {\n  height: 100vh;\n  width: 216px;\n  /*float:left;*/\n  background-color: #292c2f;\n  position: fixed;\n}\n\n.divHideSide {\n  height: 100vh;\n  width: 40px;\n  float:left;\n  background-color: #FFE8BF;\n  position: fixed;\n}\n\n.marginWhenHiddenSidenav {\n  margin-left: 0px;\n}\n\n.marginWhenSidenav {\n  margin-left:216px;\n}\n\n.hidden {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
